export default "__VITE_ASSET__DTF9SAaK__"